import styles from './styles.module.css'

type BudgetCoinLoaderProps = {
  className?: string
}

export const BudgetCoinLoader = ({ className }: BudgetCoinLoaderProps) => (
  <div
    aria-label="Загрузка данных бюджета"
    className={[styles.loader, className].filter(Boolean).join(' ')}
    role="status"
  >
    {[0, 1, 2].map((coin) => (
      <span className={styles.coin} key={coin} />
    ))}
    <span className={styles.visuallyHidden}>Загрузка данных бюджета</span>
  </div>
)
